import type { Insight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useFollowedUsers } from "src/contexts"
import { useSegment } from "src/contexts/SegmentContext"
import { useUpdateDeviceSettings } from "src/hooks/deviceSettings"

export function useUpdateInsight() {
  const { currentDeviceSettings } = useFollowedUsers()
  const id = currentDeviceSettings.id
  const insights = currentDeviceSettings.insights

  const updateDeviceSettings = useUpdateDeviceSettings()

  const analyticsRef = useSegment()

  const updateInsight = useMemo(
    () => !updateDeviceSettings ? undefined : (oldInsight: Insight, newInsight: Insight) => {
      const data = {
        id,
        insights: insights.map(
          (i: Insight) => {
            if (i.key === oldInsight.key && i.range === oldInsight.range) {
              return newInsight
            }
            return i

          },
        ),
      }

      const response = updateDeviceSettings(data)

      void analyticsRef.current.track(
        "Insight Tile Edited",
        {
          "Tile Type": newInsight.key,
        },
      )

      return response
    },
    [
      analyticsRef,
      id,
      insights,
      updateDeviceSettings,
    ],
  )

  return updateInsight
}
